export default "__VITE_ASSET__336dP9zQ__"